import { render, staticRenderFns } from "./DownTimePareto.vue?vue&type=template&id=7ba59923&scoped=true"
import script from "./DownTimePareto.vue?vue&type=script&lang=js"
export * from "./DownTimePareto.vue?vue&type=script&lang=js"
import style0 from "./DownTimePareto.vue?vue&type=style&index=0&id=7ba59923&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba59923",
  null
  
)

export default component.exports